<script lang="ts">
import { DrawerId, openDrawer } from '@/modules/drawers'
import { widgetOptions } from '@/modules/options'
import { Key } from '@/modules/textarea'
import { getHostWindow } from '@/utils/window'

type Props = {
	label: string
	isTicketForm?: boolean
}

let { label, isTicketForm }: Props = $props()

const handlePrivacyNoticeClick = () => {
	const { privacyNoticeUrl } = widgetOptions.getOptions()
	if (privacyNoticeUrl && !isTicketForm) {
		getHostWindow().open(privacyNoticeUrl, '_blank')
		return
	}

	openDrawer(DrawerId.GdprAndPrivacy, { useStack: true })
}
</script>

<div
	role="link"
	tabindex="0"
	onclick={handlePrivacyNoticeClick}
	onkeydown={(e) => e.key === Key.Enter && handlePrivacyNoticeClick()}
	class="inline-flex text-xs text-slate-500 hover:text-slate-800 underline cursor-pointer transition-colors"
>
	{label}
</div>
